export default {
  set_error(state, error) {
    state.errors = error;
  },
  set_shippings(state, { shippings }) {
    state.shippings = shippings.data;
    state.totalCount = shippings.total;
    state.count = shippings.total;
  },
  set_loading(state) {
    state.loading = true;
  },
  unset_loading(state) {
    state.loading = false;
  }
};
